import { Pipe, PipeTransform } from '@angular/core';

/** Event / venue row fields (snake_case API and mapped camelCase). */
export type AddressFormattingInput =
  | Record<string, unknown>
  | null
  | undefined;

function trimmedString(value: unknown): string {
  if (value == null) {
    return '';
  }
  const s = String(value).trim();
  return s;
}

function firstNonEmpty(
  row: Record<string, unknown>,
  keys: string[]
): string {
  for (const key of keys) {
    const part = trimmedString(row[key]);
    if (part) {
      return part;
    }
  }
  return '';
}

@Pipe({
  name: 'addressFormatting',
  pure: true
})
export class AddressFormattingPipe implements PipeTransform {
  /**
   * Builds one line: venue name, street, city, state, country.
   * Omits missing or blank parts; joins with ", ".
   */
  transform(value: AddressFormattingInput): string {
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
      return '';
    }
    const row = value as Record<string, unknown>;
    const parts: string[] = [];
    const venue = firstNonEmpty(row, ['venue_name', 'venueName']);
    if (venue) {
      parts.push(venue);
    }
    const street = firstNonEmpty(row, ['street_address', 'streetAddress']);
    if (street) {
      parts.push(street);
    }
    const city = trimmedString(row['city']);
    if (city) {
      parts.push(city);
    }
    const state = trimmedString(row['state']);
    if (state) {
      parts.push(state);
    }
    const country = trimmedString(row['country']);
    if (country) {
      parts.push(country);
    }
    return parts.join(', ');
  }
}
